// @ts-nocheck
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin")({
  beforeLoad: async ({ context }) => {
    // Skip auth checks during SSR - will be checked on client hydration
    if (typeof window === "undefined") {
      return;
    }

    // The parent _authenticated layout already validated the token server-side for THIS
    // navigation and handed the roles down as context. Reuse them: re-calling the auth
    // server function here doubled the request count on every admin route change.
    const auth = context.auth;
    if (!auth?.userId) {
      throw redirect({ to: "/login" });
    }

    // SystemAdmins have full access; other staff (ContentCreator / TeamLeader) may enter the
    // admin area, while each screen and the backend API enforce the finer-grained
    // permissions. Students are bounced home.
    if (!auth.isAdmin && !auth.isStaff) {
      throw redirect({ to: "/access-denied" });
    }
  },
  component: () => <Outlet />,
});
